import { Link } from "react-router";


export default function WhySection() {
    return (
        <section id="why-us" className="why-us">
            <div className="container" data-aos="fade-up">

                <div className="row">
                    <div className="col-lg-4 d-flex align-items-stretch">
                        <div className="content">
                            <h3>Why Choose Constellation Training?</h3>
                            <h4>Your workplace, not a generic classroom</h4>
                            <p>
                                We don't run open courses in hotel conference rooms. We come to you and build every session around your site, your risks, and your team's actual roles. A warehouse gets different scenarios than a school.
                            </p>
                            <div className="text-center">
                                <Link to='/about' className="more-btn">Learn More <i className="bx bx-chevron-right"></i></Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-8 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
                        <div className="icon-boxes d-flex flex-column justify-content-center">
                            <div className="row">
                                <div className="col-xl-4 d-flex align-items-stretch">
                                    <div className="icon-box mt-4 mt-xl-0">
                                        <i className="bx bx-certification"></i>
                                        <h4>Qualifications that employers recognise</h4>
                                        <p>Our first aid courses are awarded by FAIB and mental health first aid through NUCO. Both are nationally recognised, Ofqual-regulated, and meet HSE requirements. No ambiguity when auditors or insurers ask.</p>
                                    </div>
                                </div>
                                <div className="col-xl-4 d-flex align-items-stretch">
                                    <div className="icon-box mt-4 mt-xl-0">
                                        <i className="bx bx-receipt"></i>
                                        <h4>Training people actually use</h4>
                                        <p>Most first aid training fails at the point of delivery — staff forget what they learned within weeks. We teach decision-making frameworks and repeat practical skills until they're automatic, not memorised.</p>
                                    </div>
                                </div>
                                <div className="col-xl-4 d-flex align-items-stretch">
                                    <div className="icon-box mt-4 mt-xl-0">
                                        <i className="bx bx-building"></i>
                                        <h4>Flexible without cutting corners</h4>
                                        <p>On-site at your premises, scheduled around your operations, and available across the UK. We flex on logistics, not on standards.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    )
}